import React, { Component } from "react";
//import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
//import { Link } from 'react-router-dom';
import { NavMenu } from "./NavMenu";
import "./NavMenu.css";

export class Layout extends Component {
  render() {
    return (
      <div>
        <NavMenu />
        {this.props.children}
      </div>
    );
  }
}
